// extracted by mini-css-extract-plugin
export default {"root":"Toast_root__mJgs9"};